/** Hebrew Unicode range: \u0590-\u05FF */
const HEBREW_WORD_RE = /[\u0590-\u05FF]+/g;

/** Returns true if `text` contains at least one Hebrew character. */
export function containsHebrew(text: string): boolean {
  return !!text && /[\u0590-\u05FF]/.test(text);
}

/** Returns true if the text contains at least `threshold` Hebrew words, or adaptively scales for short text */
export function isHebrewText(text: string, threshold?: number): boolean {
  if (!text) return false;
  const matches = text.match(HEBREW_WORD_RE);
  if (!matches) return false;

  if (threshold !== undefined) {
    return matches.length >= threshold;
  }

  // Dynamic threshold based on length if none provided
  const totalWords = text.trim().split(/\s+/).length;
  // If it's a short text (like user input), 1 Hebrew word is enough
  if (totalWords <= 10) return matches.length >= 1;
  // For longer text, require at least 15% Hebrew words or a hard cap of 10 words
  return matches.length >= totalWords * 0.15 || matches.length >= 10;
}
